/*
 *
 * Buildpath - Misc Javscript for PDP Video Controls/Customization
 *
 */
document.addEventListener("DOMContentLoaded", function () {
  // Buildpath - Desktop - When scroll video into view, play video.
  function initIntersectionObserver(target, callback) {
    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(callback, observerOptions);
    observer.observe(target);
  }

  function onVideoVisible(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        const video = entry.target;
        console.log("video found in onVideoVisible: ", video);
        const playButton = video.previousElementSibling;
        console.log("trying to play video");
        video.play();
        playButton.classList.add("hide");
        observer.unobserve(video);
      }
    });
  }

  /*
   *
   * Buildpath - On Desktop, allow user to click anywhere on video to play/pause
   *
   */
  let pdpGridVideos = document.querySelectorAll(".video-play-on-click");

  if (pdpGridVideos.length > 0) {
    const firstVideo = pdpGridVideos[0];

    if (firstVideo) {
      // Delay the initialization of Intersection Observer by 1 second (1000ms)
      setTimeout(() => {
        initIntersectionObserver(firstVideo, onVideoVisible);
      }, 1000);
    }

    pdpGridVideos.forEach((video) => {
      let playButton = video.previousElementSibling;

    
      console.log("playButton: ", playButton);

      playButton.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playButton.classList.add("hide");
        } else {
          video.pause();
          playButton.classList.remove("hide");
        }
      });

      video.addEventListener("click", function () {
        if (video.paused) {
          video.play();
          playButton.classList.add("hide");
        } else {
          video.pause();
          playButton.classList.remove("hide");
        }
      });
    });

  }



    var videoLink = document.querySelector(".pdp-video-link");
    var video = videoLink.querySelector("video");

    //Make the video on the page stop when user clicks on it to open it in lightbox
    videoLink.addEventListener("click", function () {
        if (video.paused) {
            video.play();
        } else {
            video.pause();            
        }
    });

    



  //End the document ready
  console.log("Buildpath - PDP Video Controls/Customization v1.0.9");
});

